import { Forms } from "@/types/form";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Styled } from "./styles";

interface Props {
    variant: "incomings" | "outgoings" | "accounts" | "assets" | "debts";
    index: number;
}

const Comment: React.FC<Props> = ({ variant, index }) => {
    const { register } = useFormContext<Forms["Report"]>();

    return (
        <Styled.TextField
            variant="outlined"
            fullWidth={true}
            {...register(`${variant}.${index}.comment`)}
        />
    );
};

export default Comment;
